import { linkNodeToJsxPrinter } from '../printers.to-jsx/common.links.js';

const linkNodeToPaperPrinter = (node, context) => {
  return [{ content: linkNodeToJsxPrinter(node, context) }];
};

export { linkNodeToPaperPrinter };
//# sourceMappingURL=common.links.js.map
